import React from "react";
import { C, Disc, Shadow } from "./Disc";
import { ExplodedView, type ExplodedPart } from "./ExplodedView";
const cx = 220;

// Grille perforation, laid out once
const grilleDots: {
  x: number;
  y: number;
}[] = [];
for (let row = 0; row < 12; row++) {
  for (let col = 0; col < 18; col++) {
    const x = cx - 102 + col * 12 + (row % 2 ? 6 : 0);
    if (x > cx + 104) continue;
    grilleDots.push({
      x,
      y: 312 + row * 12
    });
  }
}
const label = (y: number, h: number, ry: number) => y + h / 2 + ry / 2;
const parts: ExplodedPart[] = [{
  id: "base",
  label: "Weighted base",
  delta: 220,
  anchorX: cx + 116,
  labelY: label(450, 24, 32),
  node: <>
        <Shadow cx={cx} cy={520} rx={150} data-id="element-454" data-mp="244fnp8res8qd" />
        <Disc cx={cx} y={450} rx={116} ry={32} h={24} side={C.ink} top={C.inkSoft} data-id="element-455" data-mp="245gzxgk5v19o" />
      </>
}, {
  id: "battery",
  label: "Li-ion battery",
  delta: 170,
  anchorX: cx + 50,
  labelY: label(400, 40, 14),
  node: <Disc cx={cx} y={400} rx={50} ry={14} h={40} side={C.tomato} top={C.cream} sideDecor={<rect x={cx - 50} y={418} width={100} height={6} fill={C.white} strokeWidth={1.5} data-id="element-457" data-mp="2zivzff0cyidm" />} topDecor={<ellipse cx={cx} cy={400} rx={12} ry={4} fill={C.ink} data-id="element-458" data-mp="3da22tm6rd05s" />} data-id="element-456" data-mp="2ayhm9ixffxq" />
}, {
  id: "pcb",
  label: "Logic board",
  delta: 130,
  anchorX: cx + 96,
  labelY: label(380, 6, 26),
  node: <Disc cx={cx} y={380} rx={96} ry={26} h={6} side={C.greenDark} top={C.green} topDecor={<g strokeWidth={1.5} data-id="element-460" data-mp="2uldltbbebeza">
            <rect x={cx - 34} y={370} width={30} height={14} rx={2} fill={C.ink} data-id="element-461" data-mp="2ulncl149lq61" />
            <rect x={cx + 8} y={374} width={20} height={9} rx={2} fill={C.sun} data-id="element-462" data-mp="2pkpwqv6q987p" />
            <rect x={cx + 36} y={366} width={12} height={8} rx={1} fill={C.cream} data-id="element-463" data-mp="9u3o45xqpyok" />
            <circle cx={cx - 56} cy={382} r={4} fill={C.cream} data-id="element-464" data-mp="4vjynvjxu4rg" />
            <circle cx={cx + 52} cy={388} r={4} fill={C.cream} data-id="element-465" data-mp="4vabsgu6wdpz" />
          </g>} data-id="element-459" data-mp="2lkpipbnjiz16" />
}, {
  id: "driver",
  label: "40 mm driver",
  delta: 105,
  anchorX: cx + 80,
  labelY: label(325, 30, 22),
  node: <Disc cx={cx} y={325} rx={80} ry={22} h={30} side={C.inkSoft} top={C.cream} topDecor={<>
            <ellipse cx={cx} cy={327} rx={54} ry={15} fill={C.sunDeep} data-id="element-467" data-mp="3cl6utmn9mki0" />
            <ellipse cx={cx} cy={329} rx={24} ry={7} fill={C.ink} data-id="element-468" data-mp="2fylhmghd2uxd" />
          </>} data-id="element-466" data-mp="37og5s9thgekg" />
}, {
  id: "grille",
  label: "Acoustic grille",
  delta: -100,
  anchorX: cx + 110,
  labelY: label(300, 150, 30),
  node: <Disc cx={cx} y={300} rx={110} ry={30} h={150} side={C.sun} top={C.sunLight} sideDecor={<g stroke="none" fill={C.ink} opacity={0.55} data-id="element-470" data-mp="1w8i10i5c8ep1">
            {grilleDots.map(d => <circle key={`${d.x}-${d.y}`} cx={d.x} cy={d.y} r={2} data-id="element-471" data-mp="216jmtau5es47" />)}
          </g>} data-id="element-469" data-mp="2tof6gysv9f73" />
}, {
  id: "ring",
  label: "Control ring",
  delta: -170,
  anchorX: cx + 110,
  labelY: label(280, 20, 30),
  node: <Disc cx={cx} y={280} rx={110} ry={30} h={20} side={C.cream} top={C.white} topDecor={<g strokeWidth={1.5} data-id="element-473" data-mp="1fqwv669aanzm">
            <ellipse cx={cx - 74} cy={282} rx={10} ry={4} fill={C.ink} data-id="element-474" data-mp="1aphawgexklia" />
            <ellipse cx={cx + 74} cy={282} rx={10} ry={4} fill={C.ink} data-id="element-475" data-mp="1ark8pmmbrixk" />
            <ellipse cx={cx} cy={280} rx={62} ry={17} fill="none" strokeDasharray="4 5" data-id="element-476" data-mp="15xg254gz1cx0" />
          </g>} data-id="element-472" data-mp="1jpw7ibxchn13" />
}, {
  id: "cap",
  label: "Touch button",
  delta: -230,
  anchorX: cx + 40,
  labelY: label(270, 10, 11),
  node: <Disc cx={cx} y={270} rx={40} ry={11} h={10} side={C.tomatoDark} top={C.tomato} data-id="element-477" data-mp="ryzu9a7dhgda" />
}];
export function SmartSpeaker({
  active
}: {
  active: boolean;
}) {
  return <ExplodedView title="Exploded view of a smart speaker" parts={parts} active={active} width={560} height={760} labelX={430} className="h-auto w-full lg:h-full" data-id="element-478" data-mp="n29fcq7b0qtg" />;
}